export interface IAirline {
  id?: string;
  legacyId?: number | null;
  name?: string;
  iata?: string;
}

export class Airline implements IAirline {
  iata!: string;
  id!: string;
  legacyId?: number | null;
  name!: string;
}
